import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {HttpClient} from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class CollectdataService {
  url: string = 'https://coronavirus-19-api.herokuapp.com/countries';
  constructor(public http: HttpClient) { }
  getData(): Observable <any>{

    return this.http.get(this.url);
  }
}
